import React, { useState } from "react";
import "./style.scss";
import Modal from "react-modal";
import pl from "date-fns/locale/pl";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface IProps {
  value: string;
  label: string;
  name: string;
  setDate: (value: string) => void;
}

const InputDate: React.FC<IProps> = ({ value, label, name, setDate }: IProps) => {
  const [open, setOpen] = useState(false);
  const [clicked, setClicked] = useState(false);
  const { t } = useTranslation();
  const onSelectDate = (date: Date | undefined) => {
    setClicked(true);
    if (date) setDate(format(date, "yyyy-MM-dd"));
    setOpen(false);
  };

  return (
    <React.Fragment>
      <div className={"form-input-date"}>
        <label htmlFor={name}>{label}</label>

        {!clicked ? (
          <button className="button medium padding-medium button-fill-second" onClick={() => setOpen(true)}>
            {t("wybierz_dzien")}
          </button>
        ) : (
          <button className="button medium padding-medium button-fill-background-second" onClick={() => setOpen(true)}>
            {value}{" "}
          </button>
        )}
      </div>

      {open && (
        <Modal
          isOpen={open}
          onRequestClose={() => setOpen(false)}
          contentLabel="modal"
          className="modal-calendar"
          style={{ content: { minWidth: "40vmin", maxWidth: "60vmin" } }}
        >
          <div className="calendar">
            <DayPicker
              mode="single"
              locale={pl}
              selected={new Date(value)}
              fromDate={new Date()}
              onSelect={onSelectDate}
              showOutsideDays
              modifiersClassNames={{
                selected: "my-selected",
                today: "my-today",
              }}
            />
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default InputDate;
